import * as React from 'react';
import {GRAY_600} from '../constants/Colors';
const CloseIcon = ({color}) => <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
        <path d="m0 0h24v24h-24z"/>
        <path d="m3 3 17.678 17.678m0-17.678-17.678 17.678"
              stroke={ color || GRAY_600} strokeLinecap="round" strokeWidth="2"/>
        </g>
    </svg>;

export default CloseIcon;
